export function SearchArrayData(query, dataArray) {
    // Convert query to lowercase for case-insensitive search
    const searchTerm = query.toLowerCase();

    // Filter dataArray based on the search term
    const filteredData = dataArray.filter((item) => {
        const itemLowercase = item.toLowerCase();
        return itemLowercase.includes(searchTerm);
    });

    return filteredData;
}